// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabCmpLegIntClaim extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.cmp_leg_int_claim";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabCmpLegIntClaim {
        this.VALUES ??= this.completar({
            "valor": {
                "da": "Berettiget interesse",
                "de": "Berechtigtes Interesse",
                "en": "Legitimate interest",
                "es": "Interés legítimo",
                "fr": "Intérêt légitime",
                "it": "Interesse legittimo",
                "nl": "Gerechtvaardigd belang",
                "pt": "Interesse legítimo",
                "ru": "Законный интерес",
                "pt-BR": "Interesse legítimo"
            },
            "defecto": "Interés legítimo"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
